export default [
  {
    path: '/takim',
    name: 'takim-list',
    component: () => import('./index.vue'),
    meta: {
      public: false,
      title: 'takim.Baslik',
      yetki: { k: [2002302] },
    },
  },
  {
    path: '/takim/hedef/:uuid',
    name: 'takim-hedef-list',
    component: () => import('./hedef/index.vue'),
    meta: {
      public: false,
      title: 'takim_hedef.Baslik',
      yetki: { k: [2002402] },
    },
  },
]
